<div class="container">
  <form [formGroup]="userDataFormControl" (ngSubmit)="onSubmitUserDataForm()">
    <mat-toolbar>      
      <span>Datos personales</span>
      <span class="sgd-spacer"></span>
      <button mat-flat-button class="btn-login" type="submit"
          [disabled]="!userDataFormControl.valid || fetchingUpdateUser">
          <div class="btn-login-content">
            @if (fetchingUpdateUser) {
            <mat-spinner diameter="20" color="tertiary"></mat-spinner>
            }@else{
            Guardar
            }
          </div>
        </button>
    </mat-toolbar>
    <br>
    <div class="row">
      <div class="col-md-6">
        <input type="number" hidden required formControlName="id">
        <mat-form-field class="full-width">
          <mat-label>Ciruc</mat-label>
          <input matInput placeholder="1234567890" formControlName="ciruc" required readonly />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>T&iacute;tulo</mat-label>
          <input matInput placeholder="Ing. Industrial" formControlName="titulo" required />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Nombres</mat-label>
          <input matInput placeholder="Juan Esteban" formControlName="nombres" required />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Apellidos</mat-label>
          <input matInput placeholder="S&aacute;nchez Almeida" formControlName="apellidos" required />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Correo</mat-label>
          <input type="email" matInput placeholder="salmeida@ex.com" formControlName="correo" required />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Cargo</mat-label>
          <input matInput placeholder="Gerente" formControlName="cargo" required />
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>G&eacute;nero</mat-label>
          <mat-select formControlName="genero">
            <mat-option value="0">Masculino</mat-option>
            <mat-option value="1">Femenino</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="full-width">
          <mat-label>Estado civil</mat-label>
          <mat-select formControlName="estadoCivil">
            <mat-option value="0">Soltero</mat-option>
            <mat-option value="1">Casado</mat-option>
            <mat-option value="2">Divorciado</mat-option>
            <mat-option value="3">Viudo</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-checkbox formControlName="notificarme">
          Deseo recibir notificaciones por correo electr&oacute;nico
        </mat-checkbox>
      </div>
    </div>
  </form>
  <br>
  <mat-card appearance="outlined" style="padding: 24px;">
    <div class="row">
      <div class="col-12" style="display: flex;">
        <span class="sgd-spacer"></span> <button mat-flat-button (click)="onSavePhoto()">
          Guardar fotograf&iacute;a
        </button>
        <br>
        <span class="sgd-spacer"></span> <button mat-flat-button (click)="onQuitarPhoto()">
          Quitar fotograf&iacute;a
        </button>
        <br>
      </div>
      <div class="col-sm-6">
        <div class="form-photo-cropper-container" style="min-width: 255px">
          <image-cropper [alignImage]="'center'" [roundCropper]="true" [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true" [aspectRatio]="1/1" format="png" (imageCropped)="imageCropped($event)"
            [imageBase64]="currentUserPhoto?.foto">
          </image-cropper>
        </div>
        <div
          style="text-align: center;line-height: normal;justify-content: center;justify-content: space-between; display: flex; padding: 0px 25%;">
          <input type="file" id="fileInput" (change)="fileChangeEvent($event)" hidden />
          <button mat-flat-button  (click)="triggerFileInput()" style="min-width: 155px;">
            <mat-icon>attach_file</mat-icon>
            Elegir archivo
          </button>
        </div>
      </div>
      <div class="col-sm-6">
        <div style="text-align: center; padding: 8px 20%; min-width: 255px;">
          @if (croppedImage || photoUrl) {
            <img [src]="croppedImage || photoUrl" style="border-radius: 100%" width="80%" />
          } @else {
            <div style="width: 80%; aspect-ratio: 1; border-radius: 100%; background: #f0f0f0; display: flex; align-items: center; justify-content: center; margin: 0 auto;">
              <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #999;">person</mat-icon>
            </div>
          }
        </div>
        <p style="text-align: center;">Previsualizaci&oacute;n</p>
      </div>
    </div>
  </mat-card>
</div>
